import { OFFERINGS } from "./constants";
import { Grid, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import { motion } from "framer-motion";

export default function Offerings() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  return (
    <Box maxWidth={1000} mx="auto" my={{ xs: 12, sm: 20 }} px={1}>
      <motion.div
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        <Stack spacing={{ xs: 8, sm: 16 }}>
          {OFFERINGS.map(({ label, title, desc, img }, idx) => (
            <motion.div key={idx} variants={itemVariants}>
            <Grid
              container
              direction={idx % 2 === 0 ? "row-reverse" : "row"}
              columns={{ xs: 6, md: 12 }}
              spacing={{ xs: 3, md: 6 }}
              alignItems="center"
            >
              <Grid item xs={6}>
                <Stack alignItems="start" spacing={2}>
                  <Typography
                    variant="body2"
                    color="accent.main"
                    textTransform="uppercase"
                  >
                    {label}
                  </Typography>
                  <Typography variant="h3">{title}</Typography>
                  <Typography
                    variant="body1"
                    fontWeight={500}
                    color="text.secondary"
                  >
                    {desc}
                  </Typography>
                  {/* <Stack direction="row" gap={2} alignItems="center" mt={4}>
                   <IconButton sx={{border: "1px solid"}}>
                    <Location />
                   </IconButton>
                   <Typography
                    variant="body1"
                    fontWeight={500}
                    color="text.secondary"
                  >
                    {distance}
                  </Typography>
                  </Stack> */}
                </Stack>
              </Grid>
              <Grid item xs={6}>
                <Box flex={1}>
                  <picture>
                    <source srcSet={`${img}.webp`} type="image/webp" />
                    <img
                      style={{ borderRadius: 32 }}
                      src={`${img}.png`}
                      alt="img"
                      width="100%"
                    />
                  </picture>
                </Box>
              </Grid>
            </Grid>
            </motion.div>
          ))}
        </Stack>
      </motion.div>
    </Box>
  );
}
